import PropTypes from "prop-types";

/** VA / Trustee / Probate bond form headers (`*BondHeader`). */
export const BOND_FORM_HEADER_PROPS = {
  onOpenCalculator: PropTypes.func,
  onOpenSupport: PropTypes.func,
  isGuest: PropTypes.bool,
};

/** Principals.jsx, Trustees.jsx */
export const BOND_PRINCIPAL_SHELL_VA_TRUSTEE = {
  data: PropTypes.shape({ guardians: PropTypes.array }),
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  isGuest: PropTypes.bool,
};

/** PersonalRepresentatives.jsx */
export const BOND_PRINCIPAL_SHELL_PROBATE = {
  data: PropTypes.shape({ guardians: PropTypes.array }),
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  errors: PropTypes.object,
  isGuest: PropTypes.bool,
};

/** Guardians.jsx (`GuardianForm`) */
export const BOND_PRINCIPAL_SHELL_GUARDIANSHIP = {
  data: PropTypes.shape({ guardians: PropTypes.array }),
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  errors: PropTypes.object,
  isGuest: PropTypes.bool,
};

/** VA BasicInformation, Guardian Basic uses TRUSTEE shape with global defaults. */
export const BOND_STEP_DATA_UPDATE_ERRORS = {
  data: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

export const BOND_STEP_GLOBAL_DATA_ERRORS = {
  data: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object,
  errors: PropTypes.object,
};

export const BOND_STEP_ATTORNEY_VA_TRUSTEE = {
  globalData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  isGuest: PropTypes.bool,
};

export const BOND_STEP_ATTORNEY_PROBATE = {
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  errors: PropTypes.object,
  isGuest: PropTypes.bool,
};

export const BOND_STEP_ATTORNEY_GUARDIANSHIP = {
  globalData: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  errors: PropTypes.object,
  setErrors: PropTypes.func,
  isGuest: PropTypes.bool,
};

export const BOND_STEP_DOCUMENT_UPLOAD = {
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
};

export const BOND_STEP_ESTATE_DETAILS = {
  data: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  errors: PropTypes.object,
};

export const BOND_STEP_BASIC_TRUSTEE_GUARDIANSHIP = {
  globalData: PropTypes.object,
  data: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  errors: PropTypes.object,
};

export const BOND_STEP_BASIC_PROBATE = {
  globalData: PropTypes.object,
  data: PropTypes.object,
  updateData: PropTypes.func.isRequired,
  errors: PropTypes.object,
  layoutView: PropTypes.string,
};
